import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// A stale index bundle can reference lazy chunks that no longer exist after a
// new deploy. Reload once (guarded) so the browser picks up the fresh build.
const RELOAD_KEY = "chunk-reload-at";
const handleChunkError = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
  if (Date.now() - last < 15000) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};

window.addEventListener("vite:preloadError", handleChunkError);
window.addEventListener("unhandledrejection", (e) => {
  const msg = String((e.reason as Error)?.message ?? e.reason ?? "");
  if (msg.includes("Failed to fetch dynamically imported module")) handleChunkError();
});
window.addEventListener("error", (e) => {
  if (String(e.message ?? "").includes("Failed to fetch dynamically imported module"))
    handleChunkError();
});


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
